import React from "react";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { Link, graphql, useStaticQuery } from "gatsby";

export default function CookieBanner() {

    const data = useStaticQuery(graphql`
        query {
            salesChannel {
                id
                name
                email
                logo
                phone
                address
                type
                metadata
            }
        }
    `);

    const metadata = data?.salesChannel?.metadata;
    const cookieMessage = JSON.parse(metadata ?? "{}").settings?.cookieMessage ?? "Accept default cookies";

    return (
        <CookieConsent
            location="bottom"
            buttonText="Accept"
            declineButtonText="Decline"
            cookieName="gatsby-gdpr-google-analytics"
            style={{ background: "#35342e" }}
            contentStyle={{ margin: "0 0 0 0" }}
            buttonStyle={{ background: "#a7c838", color: "#35342e", padding: "10px", margin: "0" }}
            containerClasses="md:flex-row-reverse items-center py-10 px-5 md:px-[200px]"
            contentClasses="text-md xl:text-xl md:pl-5"
            buttonWrapperClasses="w-full md:w-auto mt-5 md:mt-0 flex justify-center md:justify-start md:block"
            buttonClasses="text-xl font-bold w-1/2 md:w-auto"
            expires={150}
        >
            {cookieMessage}
        </CookieConsent>
    );
}
